export type DeliveryRangeDays = 7 | 15 | 30 | 60 | 90;

export const DELIVERY_RANGE_DAYS: readonly DeliveryRangeDays[] = [7, 15, 30, 60, 90];

// The WIDEST range, not the narrowest one the list starts at. A pristine search is the one an
// agent runs before knowing anything about the delivery being asked about, so the default that
// costs nothing is the one that cannot hide it: a narrow window answers a three-week-old case with
// an empty table, which reads as «este edificio no tiene entregas» and has to be widened by hand.
export const DEFAULT_DELIVERY_RANGE: DeliveryRangeDays = 90;

// TODO: i18n — copy en ES hasta Fase 1.
export function deliveryRangeLabel(days: DeliveryRangeDays): string {
  return `Últimos ${String(days)} días`;
}

// `Select` speaks strings and the URL state speaks the literal union, so the narrowing lives
// here once. Anything outside the range is not coerced: an out-of-range value can only reach
// this from a hand-edited URL, which the state schema already rejects, so returning null keeps
// the two agreeing instead of inventing a range the backend would 400 on.
export function parseDeliveryRange(value: string): DeliveryRangeDays | null {
  const parsed = Number(value);
  return DELIVERY_RANGE_DAYS.find((d) => d === parsed) ?? null;
}

export const deliveryRangeOptions: { value: string; label: string }[] = DELIVERY_RANGE_DAYS.map(
  (days) => ({ value: String(days), label: deliveryRangeLabel(days) }),
);
